import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
export default function makeSingle(baseClass) {
    var SingleObjectResource = function (_baseClass) {
        _inherits(SingleObjectResource, _baseClass);

        function SingleObjectResource() {
            _classCallCheck(this, SingleObjectResource);

            return _possibleConstructorReturn(this, (SingleObjectResource.__proto__ || _Object$getPrototypeOf(SingleObjectResource)).apply(this, arguments));
        }

        _createClass(SingleObjectResource, [{
            key: 'fetch',
            value: function fetch(kwargs, query) {
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'get';

                var thePath = this.buildThePath(kwargs);
                return this.handleRequest(this.createRequest(method, thePath, query));
            }
        }, {
            key: 'head',
            value: function head(kwargs, query) {
                return this.fetch(kwargs, query, 'head');
            }
        }, {
            key: 'options',
            value: function options(kwargs, query) {
                return this.fetch(kwargs, query, 'options');
            }
        }, {
            key: 'post',
            value: function post(kwargs, data, query) {
                var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'post';

                var thePath = this.buildThePath(kwargs);

                return this.handleRequest(this.createRequest(method, thePath, query, data || {}));
            }
        }, {
            key: 'patch',
            value: function patch(kwargs, data, query) {
                return this.post(kwargs, data, query, 'patch');
            }
        }, {
            key: 'put',
            value: function put(kwargs, data, query) {
                return this.post(kwargs, data, query, 'put');
            }
        }, {
            key: 'del',
            value: function del(kwargs, data, query) {
                return this.post(kwargs, data, query, 'del');
            }
        }]);

        return SingleObjectResource;
    }(baseClass);

    return SingleObjectResource;
}


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/single.js
// module id = 1149
// module chunks = 0